module.exports = __webpack_public_path__ + "static/media/5_viewer_realtime.1a38aabd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/5_viewer_realtime.png
// module id = 318
// module chunks = 0